import { render, staticRenderFns } from "./ReviewDVIR.vue?vue&type=template&id=bffcaaa4&scoped=true&"
import script from "./ReviewDVIR.vue?vue&type=script&lang=js&"
export * from "./ReviewDVIR.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDVIR.vue?vue&type=style&index=0&id=bffcaaa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffcaaa4",
  null
  
)

export default component.exports